import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth';

export const useAuthInit = () => {
  const { token, fetchUser, isAuthenticated, user } = useAuthStore();
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      // Give Zustand time to rehydrate from localStorage
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // If we have a token but no user data, fetch the user
      if (token && isAuthenticated && !user) {
        try {
          await fetchUser();
        } catch (error) {
          console.log('Failed to fetch user data, token might be expired');
        }
      }
      
      setIsInitializing(false);
    };

    initAuth();
  }, []); // Only run once on app mount

  return { isAuthenticated, isInitializing };
};